import { useAuth } from "@myplant-io/hooks";
import { useSnackbar } from "@myplant-io/snackbar";
import {
  createApiClient,
  getApiBaseUrl,
  ApiError,
  ApiClientProvider as _ApiClientProvider,
} from "@myplant-io/utils/api";
import { PropsWithChildren } from "react";
import { defineMessages, useIntl } from "react-intl";
import { API_BASE_URL } from "../constants";

const messages = defineMessages({
  unauthorized: {
    id: "upstream.error.unauthorized",
    defaultMessage: "You seem to have been logged out.",
  },
  reload: {
    id: "upstream.error.unauthorized.action.reload",
    defaultMessage: "Reload",
  },
});

export function ApiClientProvider(props: PropsWithChildren<unknown>) {
  const intl = useIntl();
  const { showErrorMessage } = useSnackbar();
  const { data: authData } = useAuth(API_BASE_URL);
  const user = authData?.user;

  const apiClient = createApiClient({
    baseUrl: getApiBaseUrl("/"),
    onError: (error) => {
      const statusCode = (error as ApiError)?.statusCode;
      if (
        statusCode &&
        [401].includes(statusCode) &&
        user?.name &&
        !(
          location.pathname === "/" ||
          location.pathname === "/login" ||
          location.pathname.startsWith("/mode-import")
        )
      ) {
        showErrorMessage({
          message: intl.formatMessage(messages.unauthorized),
          action: intl.formatMessage(messages.reload),
          handleAction: () => location.reload(),
        });
      }
      throw error;
    },
  });

  return (
    <_ApiClientProvider apiClient={apiClient}>
      {props.children}
    </_ApiClientProvider>
  );
}
